import React from "react";
import { Route, Redirect } from "react-router-dom";
import { canAccessRoute, isSuperAdmin, isTeamMember, getFirstAllowedRoute } from '../services/PermissionService';

const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
	moduleId, // ACM: Optional module ID for permission check
	...rest
}) => (
		<Route
			{...rest}
			render={props => {

				if (isAuthProtected && !localStorage.getItem("token")) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}

				// ACM: Check module-level access if protected route
				if (isAuthProtected && localStorage.getItem("token")) {
					const path = props.location.pathname;

					// Profile is always accessible for any logged-in admin
					const alwaysAllowedPaths = ['/profile', '/Notification', '/ManageNotification', '/AppVersionSettings'];
					const isAlwaysAllowed = alwaysAllowedPaths.some(p => path.toLowerCase().startsWith(p.toLowerCase()));

					// Skip permission check for always-allowed paths
					if (!isAlwaysAllowed && !canAccessRoute(path)) {
						// Redirect to first allowed route based on user's permissions
						const firstAllowedRoute = getFirstAllowedRoute();
						return (
							<Redirect to={{ pathname: firstAllowedRoute, state: { from: props.location, noAccess: true } }} />
						);
					}
				}

				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			}}
		/>




		
	);

export default AppRoute;

